var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dtpage-status-float"},_vm._l((_vm.statusTV),function(item){return _c('div',{key:item.name,staticClass:"dsf-item"},[_c('div',{staticClass:"dsf-item--color",style:({
        backgroundColor: _vm.detectColorValue(item.value)
          ? item.value
          : ("#" + (item.value)),
      })}),_c('div',{staticClass:"dsf-item--text"},[_vm._v(_vm._s(item.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }